import { MultipleChoiceAnswer } from "@/pages/quiz/base/questions/multipleChoice";

export enum ExclusiveAnswer {
  None = "none",
  Another = "another",
}

const EXCLUSIVE_ANSWERS = new Set<string>([
  ExclusiveAnswer.None,
  ExclusiveAnswer.Another,
]);

export const getUpdatedExclusiveQuestionValue = (
  value: string,
  prev: MultipleChoiceAnswer,
): MultipleChoiceAnswer => {
  const currentAnswers = prev?.answer ?? [];

  if (EXCLUSIVE_ANSWERS.has(value)) {
    return { answer: [value] };
  }

  if (currentAnswers.some((a) => EXCLUSIVE_ANSWERS.has(a))) {
    return { answer: [value] };
  }

  const updatedAnswers = currentAnswers.includes(value)
    ? currentAnswers.filter((answer) => answer !== value)
    : [...currentAnswers, value];

  const selected = new Set(updatedAnswers);
  const cleanedInputValue = Object.fromEntries(
    Object.entries(prev?.inputValue ?? {}).filter(([k]) => selected.has(k)),
  );

  return {
    answer: updatedAnswers,
    ...(Object.keys(cleanedInputValue).length
      ? { inputValue: cleanedInputValue }
      : {}),
  };
};
